'use strict';

module.exports = '2.23.0';



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch-helper/src/version.js
// module id = 175
// module chunks = 0